import styled from "styled-components";


export const CapabilitiesBody = styled.section`
margin-bottom:6%;
`

export const CapabilitiesHead = styled.div`
display:flex;
justify-content: space-between;
margin-bottom:7%;
@media (max-width:47.94rem) {
   display:block;
}
`

export const CapabilitiesItems = styled.div`
display:flex;
column-gap: 1.5rem;
@media (max-width:47.94rem) {
   display:block;
}
`

export const CapabilitiesTitle = styled.div`
font-size:1.1rem;
margin-bottom: 0.6rem;
text-transform:uppercase;
font-weight: 700;
white-space: nowrap;
letter-spacing: 0.15rem;
`

export const CapabilitiesText = styled.div`
flex: 0 0 40%;
font-size: 0.7rem;
line-height: 1.2rem;
margin: 1rem 0rem;
`